import { isEmpty } from 'lodash-es'
import AIMEOS from '@/js/helper/aimeos-constants.js'

export default {
  methods: {
    formatGroupPrices(groupPrices, translationKey = '') {
      return !groupPrices || isEmpty(groupPrices)
        ? { empty: { formatted: this.$t('product.priceempty'), brands: [] } }
        : Object.entries(groupPrices).reduce((acc, [client, price]) => {
            // console.log(
            //   '🚀 ~ file: product-group-prices-mixin.js:15 ~ :Object.entries ~ client, price:',
            //   client,
            //   price,
            // )

            const value = price[0]?.value
            const zzca = price[0]?.[AIMEOS.PRODUCTS.RELATIONSHIP.CONFIG.ZZCA]
            const currency = price[0]?.currency
            const discountText = price[0]?.discount
              ? `${this.$n(price[0]?.discount, 'noFraction')}%`
              : undefined
            if (!value || !currency) {
              return acc
            }
            acc[client] = {
              ...price[0],
              discountText,
              formatted: translationKey
                ? this.$t(translationKey, {
                    price: this.$n(value, { key: 'currency', currency }),
                  })
                : this.$n(value, { key: 'currency', currency }),
              zzca: zzca ? this.$n(zzca, { key: 'currency', currency }) : undefined,
            }
            return acc
          }, {})
    },
  },
}
